import React from "react";
import { Link } from "react-router-dom";
import Header from "components/Header";
import Hero from "components/Hero";
import programsImage from "assets/programs.png";
import Logo from "components/Logo";
import {
  AiOutlineTwitter,
  AiFillLinkedin,
  AiFillFacebook,
  AiFillYoutube,
  AiOutlineInstagram,
} from "react-icons/ai";
import { ImLinkedin2 } from "react-icons/im";
import { RiFacebookFill } from "react-icons/ri";
import video1 from "assets/gallery/1.webp";
import video2 from "assets/gallery/02.webp";
import video3 from "assets/gallery/03.png";
import video4 from "assets/gallery/04.webp";
import video5 from "assets/gallery/05.jpg";
import video6 from "assets/gallery/06.jpg";
import video7 from "assets/gallery/07.webp";
import video8 from "assets/gallery/08.jpg";

function Home() {
  return (
    <>
      <Header />
      <Hero />
      <main>
        <section className="p-24  flex justify-center items-center">
          <ul
            className="w-full 2xl:w-9/12 grid text-center xl:grid-cols-4 grid-cols-1 xl:items-center xl:justify-center
           xl:self-center xl:grid-rows-2 grid-rows-4 font-extrabold  gap-20 text-xl "
          >
            <li className="2 mr-0">
              <div className=" text-black  text-8xl">10</div>
              <div className="text-primary  mt-4">جوائز محلية وإقليمية</div>
            </li>
            <li className="">
              <div className="text-8xl text-black ">10</div>
              <div className="text-primary  mt-4">برامج اذاعية</div>
            </li>

            <li className="">
              <div className="text-8xl text-black ">91+</div>
              <div className="text-primary  mt-4">فلما وثائقيا</div>
            </li>
            <li className="">
              <div className="text-8xl text-black ">+600</div>
              <div className="text-primary  mt-4">ألف متابع</div>
            </li>
            <li className="">
              <div className="text-8xl text-black ">30+</div>
              <div className="text-primary  mt-4">مليون مشاهدة على الأفلام</div>
            </li>
            <li className="">
              <div className="text-8xl text-black ">80+</div>
              <div className="text-primary  mt-4">مليون استماع</div>
            </li>
            <li className="">
              <div className="text-8xl text-black ">+550</div>
              <div className="text-primary  mt-4">ألف تحميل أسبوعيًا</div>
            </li>
            <li className="">
              <div className="text-8xl text-black ">21</div>
              <div className="text-primary  mt-4">حلقة جديدة شهريًا</div>
            </li>
          </ul>
        </section>
        <section className="bg-black flex flex-col  items-center text-primary p-6 text-center">
          <div className="w-full ">
            <ul className="flex justify-between mb-3 w-full container ">
              <img
                src={video8}
                className="w-96 h-52  rounded-md mr-6 img-left"
              />
              <img
                src={video2}
                className="w-96 h-52 object-cover rounded-md mr-6 img-left"
              />
              <img
                src={video3}
                className="w-96 h-52 rounded-md mr-6  img-left"
              />
              <img
                src={video4}
                className="w-96 h-52 rounded-md mr-6 img-left"
              />
              <img
                src={video5}
                className="w-96 h-52 rounded-md mr-6 img-left"
              />
              <img
                src={video6}
                className="w-96 h-52 rounded-md mr-6 img-left "
              />
              <img
                src={video7}
                className="w-96 h-52 rounded-md mr-6 img-left"
              />
              <img
                src={video8}
                className="w-96 h-52 rounded-md mr-6 img-left"
              />
            </ul>
          </div>
          <div className="w-full z-50 mt-6">
            <ul className="flex justify-between  w-full container ">
              <img
                src={video1}
                className="w-96 h-52  rounded-md mr-6 img-right"
              />
              <img
                src={video2}
                className="w-96 h-52 object-cover rounded-md mr-6 img-right"
              />
              <img
                src={video3}
                className="w-96 h-52 rounded-md mr-6  img-right"
              />
              <img
                src={video4}
                className="w-96 h-52 rounded-md mr-6  img-right"
              />
              <img
                src={video5}
                className="w-96 h-52 rounded-md mr-6 img-right"
              />
              <img
                src={video6}
                className="w-96 h-52 rounded-md mr-6 img-right"
              />

              <img
                src={video8}
                className="w-96 h-52 rounded-md mr-6 img-right"
              />
            </ul>
          </div>
          <hgroup className="xl:w-1/2  text-center mt-20 mb-16">
            <h1 className="text-4xl font-bold mb-6 ">
              أكبر منصة لإنتاج الأفلام السعودية
            </h1>
            <h2 className=" text-xl text-white   ">
              تخصصت ثمانية في صناعة الأفلام الوثائقية إيمانًا منها بأهميتها على
              المدى القصير والبعيد. ونؤمن أن هناك الملايين من العرب الذين
              يشاركونا ذات الإيمان وذات الاهتمام. حتى بتنا اليوم أكبر منتج
              للأفلام الوثائقية في السعودية، وواحدة من أبرز الشركات في هذا
              المجال عربيًا. ننتج عشرات الأفلام بين أفلام خاصة بنا، أو أفلام
              نتشارك فيها مع عملاءنا. فخلقنا سوقًا ضخمًا يلبي حاجة المشاهدين
              والشركات والجهات في شتّي بقاع الوطن العربي.
            </h2>
          </hgroup>
        </section>

        <section className="text-center flex flex-col pt-36 pb-44 p-4 justify-center items-center">
          <img src={programsImage} className="xl:w-1/2" />
          <hgroup className="xl:w-1/2 mt-10">
            <h1 className="font-extrabold text-4xl text-primary mt-20 mb-5">
              شبكة البودكاست الأعلى انتشارًا عربيًا
            </h1>
            <h2 className="font-semibold text-xl text-black mt-4 mb-8">
              بدأنا ثمانية ببرنامج يتيم، واليوم باتت إذاعة ثمانية تملك كوكبة من
              أميز برامج البودكاست عربيًا في مجالات متنوعة. فننتج اليوم برامج
              بودكاست خاصة بثمانية، وبرامج بودكاست لعملاءنا الذين يستفيدون من
              خبراتنا الطويلة في هذا المجال.
            </h2>
          </hgroup>
        </section>
      </main>

      <footer className="flex font-semibold text-lg flex-col justify-center items-center">
        <Logo width="8.5" />
        <ul className="flex justify-center flex-wrap mt-16 p-6">
          <li>
            <Link to="" className="mr-4 p-2">
              عن الشركة
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              الدستور
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              الوظائف
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              المدونة
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              مواد تساعد الإعلام
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              الهوية البصرية
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              سياسة الخصوصية
            </Link>
          </li>
          <li>
            <Link to="" className="mr-4 p-2">
              اتصل بنا
            </Link>
          </li>
          <li>
            <Link to="" className="p-2">
              اسئلة متكررة
            </Link>
          </li>
        </ul>

        <ul className="flex  text-center flex-wrap justify-center items-center mb-10 text-2xl xl:w-1/2">
          <li className="p-2">
            <a href="">
              <ImLinkedin2 />
            </a>
          </li>
          <li className="mr-10 p-2">
            <a href="">
              <AiOutlineTwitter />
            </a>
          </li>
          <li className="mr-10 p-2">
            <a href="">
              <RiFacebookFill />
            </a>
          </li>
          <li className="mr-10 p-2">
            <a href="">
              <AiOutlineInstagram />
            </a>
          </li>
          <li className="mr-10 p-2">
            <a href="">
              <AiFillYoutube />
            </a>
          </li>
        </ul>
        <div className="text-center">
          2021 © جميع الحقوق محفوظة لشركة ثمانية للنشر والتوزيع
        </div>
      </footer>
      <div className="sticky text-xs right-4 bottom-4 z-50">
        <button className="p-2 mr-2 rounded-full text-base inline-block shadow-lg font-semibold bg-primary">
          نسخة تجريبية
        </button>
      </div>
    </>
  );
}

export default Home;
